
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';



export const globalApi = createApi({
    reducerPath: 'pokemonApi',
   baseQuery: fetchBaseQuery({ baseUrl: 'http://localhost:9000' }),
    endpoints: (builder) => ({})
})

  export  default globalApi;

  